"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scoredSuggestions = void 0;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var scoredSuggestions = function scoredSuggestions(options) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(phrase) {
      var values;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isPromise(options)) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return options();

            case 3:
              _context.t0 = _context.sent;
              _context.next = 7;
              break;

            case 6:
              _context.t0 = options;

            case 7:
              values = _context.t0;
              return _context.abrupt("return", values.map(function (option) {
                return {
                  subject: option.label.toLowerCase(),
                  option: option
                };
              }).map(function (_ref2) {
                var subject = _ref2.subject,
                    option = _ref2.option;
                return {
                  score: phrase.toLowerCase().split(' ').reduce(function (score, term) {
                    if (score < 0) {
                      return score;
                    }

                    var index = subject.indexOf(term);

                    if (index < 0) {
                      return index;
                    }

                    return score + term.length / (index + 1) + subject.split(term).length;
                  }, 0),
                  option: option
                };
              }).filter(function (scored) {
                return scored.score > 1;
              }).sort(function (a, b) {
                return b.score - a.score;
              }).map(function (scored) {
                return scored.option;
              }));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.scoredSuggestions = scoredSuggestions;

var isPromise = function isPromise(value) {
  return Boolean(value && typeof value === 'function');
};